function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 1H11.5C12.0625 1 12.5 1.4375 12.5 2V4.5H7.5V2C7.5 1.4375 7.9375 1 8.5 1ZM3 3H6V4.5H3C2.71875 4.5 2.5 4.71875 2.5 5V15C2.5 15.2812 2.71875 15.5 3 15.5H17C17.2812 15.5 17.5 15.2812 17.5 15V5C17.5 4.71875 17.2812 4.5 17 4.5H14V3H17C18.0938 3 19 3.90625 19 5V15C19 16.0938 18.0938 17 17 17H3C1.90625 17 1 16.0938 1 15V5C1 3.90625 1.90625 3 3 3ZM9 11H11C12.375 11 13.5 12.125 13.5 13.5C13.5 13.7812 13.2812 14 13 14H7C6.71875 14 6.5 13.7812 6.5 13.5C6.5 12.125 7.625 11 9 11ZM8.25 8C8.25 7.03125 9.03125 6.25 10 6.25C10.9688 6.25 11.75 7.03125 11.75 8C11.75 8.96875 10.9688 9.75 10 9.75C9.03125 9.75 8.25 8.96875 8.25 8Z",
  fill: "#636766"
});

function SvgSubmittedData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedData);
export default __webpack_public_path__ + "static/media/submitted-data.f3175072.svg";
export { ForwardRef as ReactComponent };